/* eslint-disable eag/match-named-export -- Pre-existing grab-bag file with several exports */
/**
 * Style constants shared by the two level gauges and the two read-only level
 * indicators. The lengths are raw CSS pixels under the no-raw-pixels skill's
 * fixed-pixel exception — none of them has a representation on the 4px spacing
 * grid (`theme.space.step`), and rounding them would visibly change the gauges.
 */

/** Thinnest line in the reviewed design; it has no representation on the 4px spacing grid. */
export const HAIRLINE = '1px';
/** Opacity of the pointer-preview overlay (0.22), as hex alpha. */
export const PREVIEW_ALPHA = '38';
/** Opacity the whole control drops to while it is disabled. */
export const DISABLED_OPACITY = 0.45;
/** Spec focus ring offset; `theme.outline.offset` is 2px, which reads too tight on the gauges. */
export const FOCUS_RING_OFFSET = '3px';
